import type { FC } from 'types/react';

import { Aside } from 'components/Aside';

import { Container, Wrapper } from './styles';

export const DashboardLayout: FC = ({ children }) => (
    <Wrapper>
        <Aside />
        <Container>{children}</Container>
    </Wrapper>
);
